<template>
  <v-dialog
    v-model="dialogIsOpen"
    max-width="600"
    :persistent="true"
  >
    <v-card class="dialog-box home-form-container">
      <h2 class="form-title">{{ $t('AddTube/Fiber') }}</h2>
      <div style="display: flex; justify-content: space-between;">
        <div class="form-item mb-4">
          <label>{{ $tc('Cable', 1) }}</label>
          <treeselect
            class="tube-form-input-select"
            v-model="object.cable"
            disableFuzzyMatching
            :options="cableOptions"
          />
        </div>
        <div class="form-item mb-4">
          <label>{{ $t('Tube') }}</label>
          <treeselect
            class="tube-form-input-select"
            v-model="object.tube"
            disableFuzzyMatching
            :options="tubeOptions"
            :placeholder="'Select a cable'"
            :disabled="!object.cable"
          />
        </div>
        <div class="form-item mb-4">
          <label>{{ $tc('Fiber', 1) }}</label>
          <treeselect
            class="tube-form-input-select"
            v-model="object.fiber"
            disableFuzzyMatching
            :options="fiberOptions"
            :normalizer="fiberOptionsNormalizer"
            :placeholder="'Select a tube'"
            :disabled="!object.tube"
          />
        </div>
      </div>

      <v-card-actions class="form-buttons" style="padding: 8px 0">
        <v-btn @click="$emit('close-form')" :ripple="false" class="secondary-button" text>
          {{ $t("Cancel") }}
        </v-btn>
        <v-btn
          class="main-button"
          text
          :ripple="false"
          :disabled="!object.fiber && !object.tube"
          @click="saveObject"
        >
          {{ $t("Save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/Home/Forms/_Molecules/InputField";
export default {
  name: "AddTubeFiberForm",
  components: {
    InputField
  },
  props: {
    dialogIsOpen: {
      type: Boolean,
      required: true
    },

    availableFibers: {
      type: Array
    }
  },
  data() {
    return {
      object: {
        cable: null,
        tube: null,
        fiber: null
      },
    };
  },

  watch: {
    /**
     * Clears the tube value when the cable changes
     */
    "object.cable"() {
      this.object.tube = undefined;
    },

    /**
     * Clears the fiber data when the tube changes
     */
    "object.tube"() {
      this.object.fiber = undefined;
    }
  },

  computed: {
    /**
     * Indicates the available cable options
     *
     * @returns {Array}
     */
    cableOptions() {
      let uniqueCables = [];
      for (const fiber of this.availableFibers) {
        if (fiber[1].hasOwnProperty("cable") && uniqueCables.findIndex(cable => cable.id === fiber[1].cable.cb_id) === -1) {
          uniqueCables.push({
            id: fiber[1].cable.cb_id,
            label: this.$i18n.tc("Cable", 1) + " " + fiber[1].cable.cb_id
          })
        }
        if (fiber[1].hasOwnProperty("splitter") && uniqueCables.findIndex(cable => cable.id === fiber[1].splitter.sp_id) === -1) {
          uniqueCables.push({
            id: fiber[1].splitter.sp_id,
            label: this.$i18n.tc("Splitter", 1) + " " + fiber[1].splitter.sp_id
          })
        }
      }
      return uniqueCables;
    },

    /**
     * Indicates the available tube options
     *
     * @returns {Array}
     */
    tubeOptions() {
      let uniqueTubes = [];
      if (this.object.cable) {
        let cableFibers = this.availableFibers.filter(fiber => this.object.cable === (fiber[1].cable ? fiber[1].cable.cb_id : fiber[1].splitter.sp_id))
        cableFibers.forEach(fiber => {
          if (uniqueTubes.findIndex(tube => tube.id === fiber[1].fiber.fb_nr_tube) === -1) {
            uniqueTubes.push({
              id: fiber[1].fiber.fb_nr_tube,
              label: this.$i18n.tc("Tube", 1) + " " + fiber[1].fiber.fb_nr_tube
            })
          }
        });
      }
      return uniqueTubes;
    },

    /**
     * Indicates the available fiber options
     *
     * @returns {Array}
     */
    fiberOptions() {
      let fibers = [];
      if (this.object.cable && this.object.tube) {
        fibers = this.availableFibers.filter(fiber =>
          this.object.cable === (fiber[1].cable ? fiber[1].cable.cb_id : fiber[1].splitter.sp_id) &&
          this.object.tube === fiber[1].fiber.fb_nr_tube
        )
      }
      return fibers;
    }
  },

  methods: {
    /**
     * Emits an event to add the object to the connections
     */
    saveObject() {
      let type = this.object.fiber ? "fiber" : "tube";
      let id = this.object.fiber ? this.object.fiber : this.object.tube;
      this.$emit('add-object', id, type, this.object.cable);
    },

    /**
     * Normalizes the values of the fiber
     *
     * @param {Object} fiber the fiber to be normalized
     * @returns {Object}
     */
    fiberOptionsNormalizer(fiber) {
      return {
        id: parseInt(fiber[0]),
        label: this.$i18n.tc("Fiber", 1) + " " + fiber[1].fiber.fb_nr_in_tube
      }
    }
  },
}
</script>

<style>
.tube-form-input-select .vue-treeselect__control {
  border: 1px solid black !important;
  border-radius: 8px !important;
}

.vue-treeselect--disabled.tube-form-input-select .vue-treeselect__control  {
  border: 1px solid #ddd !important;
  border-radius: 8px !important;
}

.v-dialog--active {
  overflow-y: visible !important;
}
</style>

<style scoped>
.form-item {
  width: 150px;
  padding-left: 5px;
  font-family: 'Lato', sans-serif;
  text-align: left;
  font-size: 12px;
}

.tube-form-input-select {
  margin-top: 5px;
}

.form-title {
  color: #42A1B6;
  text-align: start;
  padding-left: 5px;
  margin-bottom: 20px;
  font-weight: normal;
}

.tube-form-input-select .vue-treeselect__menu-container .vue-treeselect__menu {
  max-height: 90px !important;
}

.dialog-box {
  padding: 40px 45px;
  border-radius: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/InsidePlan/forms/AddTubeFiberForm.vue